import React from 'react';
import { MdClose } from "react-icons/md";
import ContainedButton from "components/layout/form/containedButton";
import medidor from 'assets/images/medidor-3.png';
import medidor1 from 'assets/images/medidor-4.png';

import {
  Body,
  Container,
  Content,
  Footer,
  Header,
  Style,
  Img,
} from "./styles";

const ModalIdentification = ({ open, toggleModal }) => {
  return (
    <Style show={open} centered animation={false}>
      <Container>
        <Header>
          <div className="wrapper">
            <span>Seu medidor</span>
          </div>
          <MdClose
            size={24}
            onClick={toggleModal}
          />
        </Header>
        <Body>
          <Content>
            <p>
              Na(s) foto(s) deve(m) constar a identificação (número do apartamento ou loja)
              e a leitura atual conforme exemplo.
            </p>
            <Img src={medidor} alt="Medidor de gás" />
            <Img src={medidor1} alt="Medidor de gás" />
          </Content>
        </Body>
        <Footer>
          <ContainedButton onClick={toggleModal}>
            Ok
          </ContainedButton>
        </Footer>
      </Container>
    </Style>
  );
};

export default ModalIdentification;
